import {createAsyncThunk} from '@reduxjs/toolkit';
import getStarRatings, {
    type GetStarRatingsResponse,
} from 'api/facilities/get-star-ratings';
import {type StarRatingPeriod} from '../star-ratings/StarRatings.types';

interface GetStarRatingsParams {
    facilityId: number;
    selectedPeriodObject: StarRatingPeriod;
}

/**
 * Fetches the star ratings data for a given facility.
 *
 * This 'thunk' action creator makes an asynchronous call to the API to retrieve
 * the star ratings data for the specified facility and period.
 *
 * Action Type: 'facilities/getStarRatingsData'
 *
 * API Service: {@link getStarRatings}
 */
export const getStarRatingsData = createAsyncThunk<
    GetStarRatingsResponse,
    GetStarRatingsParams
>(
    'facilities/getStarRatingsData',
    async ({facilityId, selectedPeriodObject}, {rejectWithValue}) => {
        try {
            const response = await getStarRatings(
                facilityId,
                selectedPeriodObject
            );

            return response;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);
